<div id="userDetails" aria-labelledby="exampleModalToggleLabel" tabindex="-1" style="display: block; padding-left: 0px;"
  aria-modal="true" role="dialog" class="modal common-right-modal benefit-modal" [class.show]="viewRole">
  <div class="modal-dialog modal-small">
    <div class="modal-content">
      <div class="modal-header upload-modal">
        <div class="title-head d-flex align-items-center">
          <button id="BtnCloseUploadDoc" type="button" class="btn-close tool-wrap position-relative"
            data-bs-dismiss="modal" aria-label="Close" (click)="closeDetails()">
            <div class="custom-tooltip tooltip-top" role="tooltip">
              <div class="arrow"></div>
              <div class="tooltip-inner"> Close </div>
            </div>
          </button>
          <h2 class="modal-title" id="exampleModalToggleLabel">
            <div class="d-flex align-items-center">
              User details
            </div>
          </h2>
        </div>
      </div>
      <div class="modal-body insurance-modal">
        <div class="row">
          <div class="col-12">
            <div class="payer-view">
              <div class="tariff-form">
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">Role Name</label>
                    <div class="detail-view">{{(roleDetails?.name)| notEmpty}}</div>
                  </div>
                  <div class="col-6">
                    <label class="form-label">User Type</label>
                    <div class="detail-view">{{(roleDetails?.user_types?.userType)| titlecase | notEmpty}}</div>
                  </div>
                  <div class="col-12">
                    <hr class="doted">
                  </div>
                  <div class="col-6">
                    <label class="form-label">Status</label>
                    <div class="detail-view">
                      <div class="status blue-circle-status" *ngIf="roleDetails?.isActive === 1"><span></span>Active</div>
                      <div class="status gray-circle-status" *ngIf="roleDetails?.isActive === 2"><span></span>Inactive</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>